import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_w2yzf89xa8: FaireBrandEntity = {
  token: "b_w2yzf89xa8",
  type: "brand",
  name: "Sunshine + Saltwater",
  avatarUrl:
    "https://cdn.faire.com/fastly/64b08d68f2b515da39483e68aa5a1a75546911df3156f1edf6f1d8d7ee72d5e8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/98f65f4847d3f1d750b895d8be761aa8334ec1df38ecb17195cd621847d31618.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/64b08d68f2b515da39483e68aa5a1a75546911df3156f1edf6f1d8d7ee72d5e8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/98f65f4847d3f1d750b895d8be761aa8334ec1df38ecb17195cd621847d31618.jpeg",
  location: "Rehoboth Beach, DE, USA",
  minimumOrderDollars: 172,
  rating: 4.9,
  reviewCount: 30,
  isTopShop: true,
  isInsider: true,
  description:
    "I want to make people happy — to make them smile. Because that’s what the beach does for me. When I’m there with the people I love — laughing, eating, drinking, just being — I feel calm, content, and at peace.\n\nThat’s what I want Sunshine + Saltwater to do for people: to bring back that feeling. That relaxed, easy, everything’s-right-with-the-world kind of vibe — the one you get when you’re at the beach.\n\nI’m Michelle — a beach girl through and through. I love summer, sunshine, and that first deep breath of ocean air. I started Sunshine + Saltwater to help people bring that beach feeling into their everyday lives, no matter where they are.\n\nOur products are beach-inspired, coastal scents, and gift items that transport you to your favorite sunny place. Everything is made in small batches with planet-friendly, plastic-free packaging and a focus on sustainability.\n\nIf my products can spark even a moment of that calm, happy, everything’s-right feeling you get at the beach… then I’ve done what I set out to do.",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:10.175Z",
    importedBy: "entity-db-cli",
  },
};
